import { Component, input } from '@angular/core';
import {
    UIHeaderComponent,
    UIPREnvPickerComponent,
    UILabelComponent,
    UIHeaderType,
    PullRequestItem
} from '@bannerflow/ui';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'header-navigation',
    imports: [UIHeaderComponent, UIPREnvPickerComponent, UILabelComponent],
    templateUrl: './header-navigation.component.html',
    styleUrl: './header-navigation.component.scss'
})
export class HeaderNavigationComponent {
    environment = environment;
    type = input<UIHeaderType>('solid');

    onPrEnvClicked(event: { repo: string; pr: PullRequestItem }): void {
        if (event.pr.previewUrl) {
            const url = new URL(event.pr.previewUrl);
            url.pathname = window.location.pathname;
            url.search = window.location.search;
            url.hash = window.location.hash;
            window.location.href = url.toString();
        }
    }
}
